import { getReservedLabelValueError } from '@ipfabric/utils/labels';
import { z } from 'zod';

export const labelValueSchema = z
  .string()
  .trim()
  .min(1, 'Value cannot be empty.')
  .max(128, 'Value can contain at most 128 characters.')
  .refine((value) => !value.includes(':'), {
    message: 'Value cannot contain a colon.',
  });

export const getLabelValueValidationError = (
  value: string,
  labelName?: string,
): string | undefined => {
  const result = labelValueSchema.safeParse(value);
  if (!result.success) {
    return result.error.issues[0]?.message;
  }

  return labelName
    ? (getReservedLabelValueError(labelName, value) ?? undefined)
    : undefined;
};
